<template>
  <div class="accent">
    <v-container fluid class="py-2">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card elevation="0" class="pg-main-card tw-mt-2 md:tw-mt-4">
            <div class="pg-header">
              <div class="pg-badge">
                <v-icon color="white">mdi-chart-box-outline</v-icon>
              </div>
              <h2 class="pg-title">TAT Reports</h2>
            </div>
            <v-divider class="mb-3" />
            <div class="pg-table">
              <tat-reports-table
                @set-table-data="setTableData"
              ></tat-reports-table>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-container class="mt-8">
        <v-row>
          <v-col class="mx-auto" cols="12" md="12">
            <div class="tw-flex tw-justify-end">
              <v-btn
                color="primary"
                :loading="isDownloading"
                :disabled="!reportsTableData.hasData"
                @click="downloadPdf"
              >
                <v-icon left> mdi-arrow-down-circle-outline </v-icon>Download
                PDF
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'
import FileSaver from 'file-saver'

export default {
  components: {
    tatReportsTable: () => import('@/components/TATReports/TATReportsTable'),
  },
  data: () => ({
    isDownloading: false,
    reportsTableData: {
      process: '',
      hasData: false,
      fromDate: '',
      toDate: '',
      page: 1,
      size: 10,
    },
  }),
  methods: {
    async downloadPdf() {
      this.isDownloading = true

      await axios
        .get(
          `/motor-assessment/api/reports/tat/${this.reportsTableData.process}/pdf`,
          {
            params: {
              fromDate: this.reportsTableData.fromDate,
              toDate: this.reportsTableData.toDate,
              page: this.reportsTableData.page,
              size: this.reportsTableData.size,
            },
            responseType: 'blob',
          }
        )
        .then((res) => {
          const contentDisposition = res.headers['content-disposition']
          const fileNameRegex = /filename="(.+?)"/
          const fileNameMatch = contentDisposition.match(fileNameRegex)
          const fileName =
            fileNameMatch && fileNameMatch[1]
              ? fileNameMatch[1]
              : `${this.reportsTableData.process}_TAT_REPORT.pdf`

          FileSaver.saveAs(res.data, fileName)
        })
        .catch((err) => {
          this.$store.commit('SNACKBAR', {
            state: 'failed',
            message: err.response.data.msg ?? 'Failed to download file',
            variant: 'error',
          })
        })
        .finally(() => (this.isDownloading = false))
    },
    setTableData(data) {
      this.reportsTableData = data
    },
  },
}
</script>

<style scoped>
/* Soft-edged card design language (matches BidSubmitted / BidDetails) */
.pg-main-card {
  border-radius: 18px;
  border: 1px solid #e8edf5;
  background: #ffffff;
  padding: 18px 20px 20px;
}
.pg-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.pg-badge {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #034ea2 0%, #0a63c4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(3, 78, 162, 0.25);
}
.pg-title {
  font-size: 20px;
  font-weight: 800;
  color: #0f2a55;
  margin: 0;
}
.pg-table {
  border-radius: 12px;
  border: 1px solid #eef2f8;
  overflow: hidden;
}
.pg-table ::v-deep .v-data-table.elevation-1 {
  box-shadow: none !important;
}
</style>
